'use client'

import { createIcon } from '@chakra-ui/icons'

export default createIcon({
  displayName: 'ChevronLeft',
  viewBox: '0 0 24 24',
  d: 'M6.6001 12C6.6001 11.7 6.7001 11.5 6.9001 11.3L15.9001 2.3C16.3001 1.9 16.9001 1.9 17.3001 2.3C17.7001 2.7 17.7001 3.3 17.3001 3.7L9.0001 12L17.3001 20.3C17.7001 20.7 17.7001 21.3 17.3001 21.7C16.9001 22.1 16.3001 22.1 15.9001 21.7L6.9001 12.7C6.7001 12.5 6.6001 12.2 6.6001 12Z',
})
